import classnames from "classnames";
import React from "react";
import SaveForLaterButton from "web/react/components/save-for-later-button/save-for-later-button";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./cart-summary.css";

interface CartSummaryOOSProps {
    id: number;
    image?: string;
    designer?: string;
    size?: string;
    isLoggedIn?: boolean;
}

export default function CartSummaryOOS({
    id,
    image,
    designer,
    size,
    isLoggedIn,
}: CartSummaryOOSProps): JSX.Element {
    return (
        <div>
            <h5 className={styles.title}>{"Out of stock..."}</h5>
            <div className={styles.subtitle}>{"Your item has gone out of stock"}</div>
            <div className={styles.item}>
                <img className={styles.image} src={image} />

                <div className={styles.details}>
                    <div className={styles.detail}>{designer}</div>

                    <div className={styles.detail}>{size}</div>

                    <div className={classnames(styles.detail, styles.oos)}>{"Out of stock"}</div>
                </div>
            </div>

            <SaveForLaterButton
                isLoggedIn={!!isLoggedIn}
                productId={id.toString()}
                type="normal"
                pageSource="oos"
            />
        </div>
    );
}
